import { connect } from "react-redux";
import { State } from "store";
import { organization } from "store/organization";
import { router } from "store/router";
import { global } from "store/global";
import { profile } from "store/profile";

const mapStateToProps = (state: State) => ({
  organization: organization.selectors.organization(state),
  organizationRefs: global.selectors.organizationRefs(state),
  currentUser: profile.selectors.User(state),
});

const mapDispatchToProps = {
  gotoOrganizationUsers: router.goto.organization.organizationView,
};

export default connect(mapStateToProps, mapDispatchToProps);
